import { APEX_API_URL } from '@/constants';
import { IBundlePromotionBanner, IBundleSlab } from '@/interfaces/bundlePromotion';
import { getAxiosInstance } from '@/utils/axios-instance';

export const getBundlePromotionSlabs = async (slug?: string): Promise<IBundleSlab[]> => {
  const params = new URLSearchParams();
  if (slug) params.append('slug', slug);

  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/bundle-promotion/slabs${params.toString() ? `?${params.toString()}` : ''}`);
  return response.data;
};

export const getBundlePromotionBanner = async (): Promise<IBundlePromotionBanner> => {
  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/bundle-promotion/banner`);
  return response.data;
};
